var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4165 11.1589L6.07022 12.4663C6.29146 12.9088 6.40208 13.13 6.54986 13.3217C6.681 13.4918 6.83351 13.6444 7.00363 13.7755C7.19535 13.9233 7.41659 14.0339 7.85907 14.2551L9.1665 14.9089L7.85907 15.5626C7.41659 15.7838 7.19535 15.8944 7.00363 16.0422C6.83351 16.1733 6.681 16.3259 6.54986 16.496C6.40208 16.6877 6.29146 16.9089 6.07022 17.3514L5.4165 18.6589L4.76279 17.3514C4.54155 16.9089 4.43093 16.6877 4.28315 16.496C4.15201 16.3259 3.9995 16.1733 3.82938 16.0422C3.63766 15.8944 3.41642 15.7838 2.97393 15.5626L1.6665 14.9089L2.97393 14.2551C3.41642 14.0339 3.63766 13.9233 3.82938 13.7755C3.9995 13.6444 4.15201 13.4918 4.28315 13.3217C4.43093 13.13 4.54155 12.9088 4.76279 12.4663L5.4165 11.1589Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.99219L13.482 4.54587C13.717 5.15689 13.8345 5.46241 14.0173 5.71939C14.1792 5.94715 14.3782 6.14614 14.606 6.30809C14.863 6.49082 15.1685 6.60833 15.7795 6.84334L18.3332 7.82552L15.7795 8.80771C15.1685 9.04272 14.863 9.16022 14.606 9.34295C14.3782 9.5049 14.1792 9.70389 14.0173 9.93165C13.8345 10.1886 13.717 10.4941 13.482 11.1052L12.4998 13.6589L11.5177 11.1052C11.2826 10.4941 11.1651 10.1886 10.9824 9.93165C10.8205 9.70389 10.6215 9.5049 10.3937 9.34295C10.1367 9.16022 9.83121 9.04272 9.22019 8.80771L6.6665 7.82552L9.22019 6.84334C9.83121 6.60833 10.1367 6.49082 10.3937 6.30809C10.6215 6.14614 10.8205 5.94715 10.9824 5.71939C11.1651 5.46241 11.2826 5.15689 11.5177 4.54587L12.4998 1.99219Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.c3f81a7ca878d339b8a0bc49078f3abc.svg";
export { ForwardRef as ReactComponent };